import { fmt } from "@/lib/api";

const STYLE = {
  1: { h: "h-40", c: "from-amber-400/40 to-amber-500/5 border-amber-400/60", t: "text-amber-300" },
  2: { h: "h-28", c: "from-slate-300/30 to-slate-400/5 border-slate-300/50", t: "text-slate-200" },
  3: { h: "h-20", c: "from-orange-400/30 to-orange-500/5 border-orange-400/50", t: "text-orange-300" },
};

export const Podium = ({ entries }) => {
  const cols = [2, 1, 3].map((p) => ({ place: p, list: entries.filter((e) => e.place === p) })).filter((c) => c.list.length);
  if (!cols.length) return null;
  return (
    <div className="flex items-end justify-center gap-3 sm:gap-5 pt-6" data-testid="podium">
      {cols.map(({ place, list }, i) => {
        const s = STYLE[place];
        return (
          <div key={place} data-testid={`podium-place-${place}`} className="flex-1 max-w-[240px] text-center rise" style={{ animationDelay: `${i * 120}ms` }}>
            {list.map((e) => (
              <div key={e.id} className="mb-2">
                <div className="font-semibold text-sm sm:text-base leading-tight line-clamp-2">{e.name}</div>
                <div className="text-[11px] text-slate-400 truncate">{e.school}</div>
              </div>
            ))}
            <div className={`font-display text-3xl font-black ${s.t}`}>{fmt(list[0].total)}</div>
            <div className={`${s.h} mt-2 rounded-t-xl border border-b-0 bg-gradient-to-b ${s.c} flex items-start justify-center pt-3`}>
              <span className={`font-display text-5xl font-black ${s.t}`}>{place}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
